<template>
  <div id="main" class="app-main">
    <router-view></router-view>

    <Modal v-model="modal1" title="设置默认值" @on-ok="modelOk" @on-cancel="cancel">
      <Input v-model="value" placeholder="请输入默认值" style="width: 300px" />
      <div style="margin-top:10px">建议填写默认值，用于属性被删除或空值时占位</div>
    </Modal>
    <svg style="display: none;">
      <symbol id="icon-plus-circle-fill" viewBox="0 0 1024 1024">
        <path
          d="M512 972.8a460.8 460.8 0 1 1 0-921.6 460.8 460.8 0 0 1 0 921.6z m64-512V312.32a5.12 5.12 0 0 0-5.12-5.12h-92.16a5.12 5.12 0 0 0-5.12 5.12V460.8h-148.48a5.12 5.12 0 0 0-5.12 5.12v92.16a5.12 5.12 0 0 0 5.12 5.12h148.48v148.48a5.12 5.12 0 0 0 5.12 5.12h92.16a5.12 5.12 0 0 0 5.12-5.12V563.2h148.48a5.12 5.12 0 0 0 5.12-5.12V465.92a5.12 5.12 0 0 0-5.12-5.12h-148.48z">
        </path>
      </symbol>
      <symbol id="icon-Percentage" viewBox="0 0 1024 1024">
        <path
          d="M742.4 563.2a179.2 179.2 0 1 1 0 358.4 179.2 179.2 0 0 1 0-358.4z m59.2384-413.2352l72.3968 72.3968L222.3616 874.0352 150.016 801.6384 801.6384 149.9648zM742.4 665.6a76.8 76.8 0 1 0 0 153.6 76.8 76.8 0 0 0 0-153.6z m-460.8-563.2a179.2 179.2 0 1 1 0 358.4 179.2 179.2 0 0 1 0-358.4z m0 102.4a76.8 76.8 0 1 0 0 153.6 76.8 76.8 0 0 0 0-153.6z">
        </path>
      </symbol>
      <symbol id="icon-copy" viewBox="0 0 1024 1024">
        <path
          d="M243.2 742.4H76.8v-665.6h665.6v166.4h-101.2224V180.3264H181.0432v458.7008H243.2V742.4z m38.4 204.8v-665.6h665.6v665.6h-665.6z m102.4-563.2v460.8h460.8v-460.8h-460.8z">
        </path>
      </symbol>
      <symbol id="icon-time-fall" viewBox="0 0 1024 1024">
        <path
          d="M972.8 507.5456c0-251.7504-206.336-455.8848-460.8-455.8848S51.2 255.7952 51.2 507.5456v8.9088c0 251.7504 206.336 455.8848 460.8 455.8848s460.8-204.1344 460.8-455.8848V512v-4.4544z m-222.8736 15.9232a25.6 25.6 0 0 1-25.6 25.6H493.568a25.6 25.6 0 0 1-25.6-25.6v-29.7984a25.6 25.6 0 0 1 0.9728-6.8608V243.8656a25.6 25.6 0 0 1 25.5488-25.5488h29.8496a25.6 25.6 0 0 1 25.6 25.6v224.1536h174.3872a25.6 25.6 0 0 1 25.6 25.6v29.7984z">
        </path>
      </symbol>
      <symbol id="icon-number-up" viewBox="0 0 1126 1024">
        <path d="M552.96 47.4112l512 877.7728H40.96z"></path>
      </symbol>
      <symbol id="icon-number-falling" viewBox="0 0 1246 1024">
        <path d="M608.053127 1024l566.685113-971.524958h-1133.370227z"></path>
      </symbol>
      <symbol id="icon-draft_fall" viewBox="0 0 1024 1024">
        <path
          d="M94.3104 1002.24a66.048 66.048 0 0 1-65.9968-66.048V578.048c0-0.8704 0.256-1.792 0.7168-2.56l120.1664-208.2304a5.2224 5.2224 0 0 0 0.7168-2.6112V95.4368A66.048 66.048 0 0 1 215.9616 29.44h478.976c1.3824 0 2.7136 0.512 3.6864 1.536l179.3536 179.3024c0.9728 1.024 1.536 2.304 1.536 3.6864v178.688c0 1.024 0.256 2.048 0.8704 2.9184l119.808 179.712a5.2224 5.2224 0 0 1 0.9216 2.9184v363.264c0 33.536-27.2384 60.7744-60.8256 60.7744H94.3104z m0.3584-433.7664a5.2224 5.2224 0 0 0 4.3008 8.192h45.7216a5.2224 5.2224 0 0 0 5.2224-5.2224V504.5248a5.2224 5.2224 0 0 0-9.5232-2.9184l-45.7216 66.8672z m668.4672-356.608a5.2224 5.2224 0 0 0 3.6864-8.9088L706.048 142.1312a5.2224 5.2224 0 0 0-8.9088 3.6864c0 36.4544 29.5936 66.048 66.048 66.048z m-60.8256 60.7744a66.048 66.048 0 0 1-65.9968-66.048v-111.104a5.2224 5.2224 0 0 0-5.2224-5.2224H276.736a66.048 66.048 0 0 0-66.048 65.9968v415.1808a5.2224 5.2224 0 0 0 5.2736 5.2224H327.168c2.816 0 5.12 2.2016 5.2224 5.0176a182.3744 182.3744 0 0 0 364.6464 0 5.2224 5.2224 0 0 1 5.2224-5.0176h111.2064a5.2224 5.2224 0 0 0 5.2224-5.2224V277.8624a5.2224 5.2224 0 0 0-5.1712-5.2224h-111.2064z m177.2032 298.8032a5.2224 5.2224 0 0 0 5.2224 5.2224h43.008a5.2224 5.2224 0 0 0 3.6864-8.9088l-43.008-43.008a5.2224 5.2224 0 0 0-8.9088 3.6864v43.008zM691.9168 394.24a5.2224 5.2224 0 0 1 5.1712 5.1712v50.3808a5.2224 5.2224 0 0 1-5.1712 5.1712H337.5104a5.2224 5.2224 0 0 1-5.2224-5.1712v-50.3808c0-2.8672 2.3552-5.2224 5.2224-5.2224h354.4064z m-121.6512-121.6512a5.2224 5.2224 0 0 1 5.2224 5.2224v50.3808a5.2224 5.2224 0 0 1-5.2224 5.2224H337.5104a5.2224 5.2224 0 0 1-5.2224-5.2224v-50.3808a5.2224 5.2224 0 0 1 5.2224-5.2224h232.7552z">
        </path>
      </symbol>
      <symbol id="icon-plus-circle-fill" viewBox="0 0 1024 1024">
        <path
          d="M512 972.8a460.8 460.8 0 1 1 0-921.6 460.8 460.8 0 0 1 0 921.6z m64-512V312.32a5.12 5.12 0 0 0-5.12-5.12h-92.16a5.12 5.12 0 0 0-5.12 5.12V460.8h-148.48a5.12 5.12 0 0 0-5.12 5.12v92.16a5.12 5.12 0 0 0 5.12 5.12h148.48v148.48a5.12 5.12 0 0 0 5.12 5.12h92.16a5.12 5.12 0 0 0 5.12-5.12V563.2h148.48a5.12 5.12 0 0 0 5.12-5.12V465.92a5.12 5.12 0 0 0-5.12-5.12h-148.48z">
        </path>
      </symbol>
      <symbol id="icon-crown-fall" viewBox="0 0 1024 1024">
        <path
          d="M958.5664 204.288l-224.2048 138.8544-214.9888-288.256a9.216 9.216 0 0 0-14.848 0l-214.8864 288.256-224.256-138.8544a9.3184 9.3184 0 0 0-14.08 9.1648l88.0128 672.256a18.7392 18.7392 0 0 0 18.432 16.1792h708.608c9.216 0 17.2032-6.912 18.3808-16.1792l88.0128-672.256a9.3696 9.3696 0 0 0-14.1824-9.1648zM512 734.208a130.2016 130.2016 0 0 1-129.7408-130.3552A130.2016 130.2016 0 0 1 512 473.4976a130.2016 130.2016 0 0 1 129.7408 130.3552A130.2016 130.2016 0 0 1 512 734.2592z m0-186.2656c-30.6176 0-55.5008 25.0368-55.5008 55.9104A55.808 55.808 0 0 0 512 659.8144c30.6688 0 55.552-25.0368 55.552-55.9616A55.808 55.808 0 0 0 512 547.9424z">
        </path>
      </symbol>
      <symbol id="icon-lightning" viewBox="0 0 1024 1024">
        <path
          d="M434.8928 962.2016c-2.4576 0-4.352-0.6656-5.632-1.8432-8.704-2.56-11.776-7.4752-9.3184-14.9504l57.856-341.6576H225.792c-6.1952 0-10.5472-2.4576-13.056-7.4752-3.7376-4.9152-3.072-10.496 1.8432-16.7936L602.9312 71.68c4.9664-7.424 10.5472-8.6528 16.7936-3.7376 6.1952 1.28 9.3184 6.2976 9.3184 14.9504l-57.856 341.6576h222.1568c6.1952 0 10.5984 2.56 13.056 7.4752a38.2464 38.2464 0 0 1 0 16.7936l-358.4 507.8016a17.92 17.92 0 0 1-13.1072 5.632z">
        </path>
      </symbol>
      <symbol id="icon-mail-fall" viewBox="0 0 1024 1024">
        <path
          d="M972.8 266.4448L510.1056 506.624 51.2 268.4416V210.944A6.144 6.144 0 0 1 57.344 204.8h909.312a6.144 6.144 0 0 1 6.144 6.144v55.5008z m0 111.2064v486.6048a6.144 6.144 0 0 1-6.144 6.144H57.344a6.144 6.144 0 0 1-6.144-6.144V379.648l456.8064 237.1584 1.3824 1.4336L972.8 377.6512z">
        </path>
      </symbol>
      <symbol id="icon-transfer-fall" viewBox="0 0 1024 1024">
        <path
          d="M965.4784 163.9936c8.0384 9.7792 9.3696 20.48 4.4032 31.8464l-299.4688 658.2272a29.5936 29.5936 0 0 1-44.7488 11.0592l-180.8896-137.4208-144.128 103.3216a27.2896 27.2896 0 0 1-24.7296 4.352 26.0096 26.0096 0 0 1-9.472-4.4544 28.8256 28.8256 0 0 1-10.8032-14.2336 29.0816 29.0816 0 0 1-0.8704-17.7664l41.9328-156.4672 514.816-371.2-590.6432 286.5152-157.696-120.1152c-9.9328-7.1168-13.7216-16.9472-11.264-29.5424a27.5456 27.5456 0 0 1 21.504-22.6816l861.696-230.656a29.0816 29.0816 0 0 1 30.3616 9.216z">
        </path>
      </symbol>
      <symbol id="icon-audiences-fall" viewBox="0 0 1024 1024">
        <path
          d="M827.5456 795.136l-175.104-83.0464a63.1296 63.1296 0 0 1-36.864-56.6784v-65.1776c4.9152-5.2736 10.5472-12.1344 16.5376-20.1728A374.4768 374.4768 0 0 0 686.592 465.92c22.4768-6.5536 38.9632-26.2144 38.9632-49.6128V346.8288a50.7904 50.7904 0 0 0-18.2784-38.5536V207.7184S728.8832 51.2 505.5488 51.2C282.2144 51.2 303.9744 207.7184 303.9744 207.7184V308.224a50.7904 50.7904 0 0 0-18.2784 38.5536v69.5296c0 18.3296 10.1376 34.4576 25.344 43.776 18.2784 75.6736 66.2528 130.0992 66.2528 130.0992v63.5904c0 23.1424-13.312 44.544-34.816 55.6032l-163.4816 84.6336C131.7888 818.4832 102.4 865.4336 102.4 916.48V972.8h806.4v-52.8896c0-52.8384-31.488-101.12-81.2544-124.7744z">
        </path>
      </symbol>
      <symbol id="icon-check-circle-fill" viewBox="0 0 1024 1024">
        <path
          d="M512 972.8a460.8 460.8 0 1 1 0-921.6 460.8 460.8 0 0 1 0 921.6z m-31.232-438.2208L401.3056 445.8496 330.7008 509.44l147.5584 164.5568 18.9952-17.1008 0.256 0.2048 247.296-222.72L676.4544 358.4 480.768 534.5792z">
        </path>
      </symbol>
      <symbol id="icon-suspened-cir-fall" viewBox="0 0 1024 1024">
        <path
          d="M512 51.2c-254.6176 0-460.8 206.1824-460.8 460.8s206.1824 460.8 460.8 460.8 460.8-206.1824 460.8-460.8-206.2336-460.8-460.8-460.8z m-46.08 645.12H373.76V327.68h92.16v368.64z m184.32 0h-92.16V327.68h92.16v368.64z">
        </path>
      </symbol>
      <symbol id="icon-plan-fall" viewBox="0 0 1024 1024">
        <path
          d="M349.2352 165.376V281.6h325.5296V165.376h194.1504a5.12 5.12 0 0 1 5.12 5.12v769.4336a5.12 5.12 0 0 1-5.12 5.12H155.136a5.12 5.12 0 0 1-5.12-5.12V170.4448a5.12 5.12 0 0 1 5.12-5.12H349.184z m51.2-86.4256h223.1296v130.2016H400.384V78.9504zM302.2336 587.776l176.3328 190.1056 269.6192-297.0624L691.6096 419.84l-213.4528 236.4928-119.7056-129.0752-56.2176 60.5696z">
        </path>
      </symbol>
      <symbol id="icon-check-circle-fill" viewBox="0 0 1024 1024">
        <path
          d="M512 972.8a460.8 460.8 0 1 1 0-921.6 460.8 460.8 0 0 1 0 921.6z m-31.232-438.2208L401.3056 445.8496 330.7008 509.44l147.5584 164.5568 18.9952-17.1008 0.256 0.2048 247.296-222.72L676.4544 358.4 480.768 534.5792z">
        </path>
      </symbol>
      <symbol id="icon-suspened-cir-fall" viewBox="0 0 1024 1024">
        <path
          d="M512 51.2c-254.6176 0-460.8 206.1824-460.8 460.8s206.1824 460.8 460.8 460.8 460.8-206.1824 460.8-460.8-206.2336-460.8-460.8-460.8z m-46.08 645.12H373.76V327.68h92.16v368.64z m184.32 0h-92.16V327.68h92.16v368.64z">
        </path>
      </symbol>
      <symbol id="icon-minus-circle-fill" viewBox="0 0 1024 1024">
        <path d="M512 972.8a460.8 460.8 0 1 1 0-921.6 460.8 460.8 0 0 1 0 921.6zM358.4 460.8v102.4h307.2V460.8H358.4z">
        </path>
      </symbol>
      <symbol id="icon-draft_fall" viewBox="0 0 1024 1024">
        <path
          d="M94.3104 1002.24a66.048 66.048 0 0 1-65.9968-66.048V578.048c0-0.8704 0.256-1.792 0.7168-2.56l120.1664-208.2304a5.2224 5.2224 0 0 0 0.7168-2.6112V95.4368A66.048 66.048 0 0 1 215.9616 29.44h478.976c1.3824 0 2.7136 0.512 3.6864 1.536l179.3536 179.3024c0.9728 1.024 1.536 2.304 1.536 3.6864v178.688c0 1.024 0.256 2.048 0.8704 2.9184l119.808 179.712a5.2224 5.2224 0 0 1 0.9216 2.9184v363.264c0 33.536-27.2384 60.7744-60.8256 60.7744H94.3104z m0.3584-433.7664a5.2224 5.2224 0 0 0 4.3008 8.192h45.7216a5.2224 5.2224 0 0 0 5.2224-5.2224V504.5248a5.2224 5.2224 0 0 0-9.5232-2.9184l-45.7216 66.8672z m668.4672-356.608a5.2224 5.2224 0 0 0 3.6864-8.9088L706.048 142.1312a5.2224 5.2224 0 0 0-8.9088 3.6864c0 36.4544 29.5936 66.048 66.048 66.048z m-60.8256 60.7744a66.048 66.048 0 0 1-65.9968-66.048v-111.104a5.2224 5.2224 0 0 0-5.2224-5.2224H276.736a66.048 66.048 0 0 0-66.048 65.9968v415.1808a5.2224 5.2224 0 0 0 5.2736 5.2224H327.168c2.816 0 5.12 2.2016 5.2224 5.0176a182.3744 182.3744 0 0 0 364.6464 0 5.2224 5.2224 0 0 1 5.2224-5.0176h111.2064a5.2224 5.2224 0 0 0 5.2224-5.2224V277.8624a5.2224 5.2224 0 0 0-5.1712-5.2224h-111.2064z m177.2032 298.8032a5.2224 5.2224 0 0 0 5.2224 5.2224h43.008a5.2224 5.2224 0 0 0 3.6864-8.9088l-43.008-43.008a5.2224 5.2224 0 0 0-8.9088 3.6864v43.008zM691.9168 394.24a5.2224 5.2224 0 0 1 5.1712 5.1712v50.3808a5.2224 5.2224 0 0 1-5.1712 5.1712H337.5104a5.2224 5.2224 0 0 1-5.2224-5.1712v-50.3808c0-2.8672 2.3552-5.2224 5.2224-5.2224h354.4064z m-121.6512-121.6512a5.2224 5.2224 0 0 1 5.2224 5.2224v50.3808a5.2224 5.2224 0 0 1-5.2224 5.2224H337.5104a5.2224 5.2224 0 0 1-5.2224-5.2224v-50.3808a5.2224 5.2224 0 0 1 5.2224-5.2224h232.7552z">
        </path>
      </symbol>

      <symbol id="icon-unorderedlist" viewBox="0 0 1024 1024">
        <path
          d="M339.6608 166.4h608.8192v102.4h-614.4v-92.16c0-5.632 2.56-10.24 5.632-10.24z m0 614.4h608.8192v102.4h-614.4v-92.16c0-5.632 2.56-10.24 5.632-10.24z m0-307.2h608.8192v102.4h-614.4v-92.16c0-5.632 2.56-10.24 5.632-10.24zM166.4 281.6a64 64 0 1 1 0-128 64 64 0 0 1 0 128z m2.9184 614.4a64 64 0 1 1 0-128 64 64 0 0 1 0 128z m-2.304-307.2a64 64 0 1 1 0-128 64 64 0 0 1 0 128z">
        </path>
      </symbol>
      <symbol id="icon-examine-fall" viewBox="0 0 1024 1024">
        <path
          d="M896.256 620.6976h-277.1456v-5.0176a114.176 114.176 0 0 1-37.2736-83.6608c0-31.0272 12.9536-59.136 33.9456-80.1792l0.1536-0.0512c0.1024-0.1536 0.256-0.2048 0.3584-0.256 7.1168-7.1168 15.1552-13.4144 23.9104-18.7392a187.8016 187.8016 0 0 0 61.5936-139.0592 188.6208 188.6208 0 1 0-377.2416 0c0 55.1424 23.8592 104.6016 61.6448 139.0592a126.7712 126.7712 0 0 1 24.2688 18.944l0.1536 0.1024c20.992 21.0432 33.8944 49.152 33.8944 80.1792 0 32.6656-14.2848 62.208-37.2736 83.6608v5.0176H130.1504a27.136 27.136 0 0 0-27.1872 27.136v161.6384h820.4288v-161.6896a27.136 27.136 0 0 0-27.136-27.0848zM139.1616 830.976h748.032v108.3904H139.1616V830.976z">
        </path>
      </symbol>
      <symbol id="icon-more-fall" viewBox="0 0 1024 1024">
        <path
          d="M166.4 640a115.2 115.2 0 1 1 0-230.4 115.2 115.2 0 0 1 0 230.4z m345.6 0A115.2 115.2 0 1 1 512 409.6a115.2 115.2 0 0 1 0 230.4z m345.6 0a115.2 115.2 0 1 1 0-230.4 115.2 115.2 0 0 1 0 230.4z">
        </path>
      </symbol>

      <symbol id="icon-arrow-sf" viewBox="0 0 1024 1024">
        <path
          d="M438.6304 870.6048L540.8256 972.8l460.8-460.8-460.3904-460.3904-102.6048 102.6048 274.5856 274.5856-684.3904 0.1024v167.1168H713.216z">
        </path>
      </symbol>
      <symbol id="icon-more2" viewBox="0 0 1024 1024">
        <path
          d="M153.6 357.1712H358.4v-203.776H153.6v203.776zM56.9856 51.2h391.68c3.1744 0 5.7344 2.56 5.7344 5.7856v391.68c0 3.1744-2.56 5.7344-5.7856 5.7344h-391.68A5.7856 5.7856 0 0 1 51.2 448.6144v-391.68C51.2 53.76 53.76 51.2 56.9856 51.2zM665.6 357.1712H870.4v-203.776H665.6v203.776zM568.9856 51.2h391.68c3.1744 0 5.7344 2.56 5.7344 5.7856v391.68c0 3.1744-2.56 5.7344-5.7856 5.7344h-391.68A5.7856 5.7856 0 0 1 563.2 448.6144v-391.68c0-3.1744 2.56-5.7344 5.7856-5.7344zM153.6 869.1712H358.4v-203.776H153.6v203.776zM56.9856 563.2h391.68c3.1744 0 5.7344 2.56 5.7344 5.7856v391.68c0 3.1744-2.56 5.7344-5.7856 5.7344h-391.68A5.7856 5.7856 0 0 1 51.2 960.6144v-391.68c0-3.1744 2.56-5.7344 5.7856-5.7344zM665.6 869.1712H870.4v-203.776H665.6v203.776zM568.9856 563.2h391.68c3.1744 0 5.7344 2.56 5.7344 5.7856v391.68c0 3.1744-2.56 5.7344-5.7856 5.7344h-391.68a5.7856 5.7856 0 0 1-5.7344-5.7856v-391.68c0-3.1744 2.56-5.7344 5.7856-5.7344z">
        </path>
      </symbol>
      <symbol id="icon-trace" viewBox="0 0 1024 1024">
        <path
          d="M257.1264 237.6704H324.096a43.2128 43.2128 0 1 1 0 86.4256H108.032V108.032a43.2128 43.2128 0 1 1 86.4256 0v69.9392A460.8 460.8 0 1 1 51.2 512a43.2128 43.2128 0 0 1 86.4256 0 374.3744 374.3744 0 1 0 119.5008-274.3296zM512 728.064a216.0128 216.0128 0 1 1 0-432.0256 216.0128 216.0128 0 0 1 0 432.0256z m0-86.4256a129.5872 129.5872 0 1 0 0-259.1744 129.5872 129.5872 0 0 0 0 259.1744z">
        </path>
      </symbol>
      <symbol id="icon-close-circle-fill" viewBox="0 0 1024 1024">

<path
  d="M512 972.8a460.8 460.8 0 1 1 0-921.6 460.8 460.8 0 0 1 0 921.6z m51.5584-460.8l152.1664-152.1664a3.6352 3.6352 0 0 0 0-5.12l-46.4384-46.4384a3.6352 3.6352 0 0 0-5.12 0L512 460.4416 359.8336 308.224a3.6352 3.6352 0 0 0-5.12 0l-46.4384 46.4384a3.6352 3.6352 0 0 0 0 5.12L460.4416 512 308.224 664.1664a3.6352 3.6352 0 0 0 0 5.12l46.4384 46.4384a3.6352 3.6352 0 0 0 5.12 0L512 563.5584l152.1664 152.1664a3.6352 3.6352 0 0 0 5.12 0l46.4384-46.4384a3.6352 3.6352 0 0 0 0-5.12L563.5584 512z">
</path>
</symbol>
    </svg>
  </div>
</template>

<script>
import Vue from 'vue'
import { h, VNode, toVNode } from 'snabbdom'
import { mapState } from "vuex";

import '@/editor'

const E = window.wangEditor

export default {
  computed: {
    ...mapState({
      metaUser: (state) => state.eventAnalysis.metaUser,
      metaEvents: (state) => state.eventAnalysis.metaEvents,
    }),
    listMap() {
      const obj = {}
      this.metaUser.forEach(item => {
        obj[item.propertyName] = item.cname
      })
      return obj
    }
  },
  data() {
    return {
      modal1: false,
      value: '',
      path22: undefined,
      positionStyle: {},
      theme: this.$store.state.app.themeColor,
    };
  },
  methods: {
    cancel() {
      this.value = ''
    },
    modelOk() {
      console.log()
      if (this.editor22 && this.path22) {
        E.SlateTransforms.setNodes(this.editor22, { defaultValue: this.value }, { at: this.path22 })
        this.value = ''
      }
    },
  },
  mounted() {

    class InsertFormulaMenu {

      constructor() {
        this.title = '插入属性' // 自定义菜单标题
        this.iconSvg = '<svg t="1714920419570" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2781" width="200" height="200"><path d="M923.86 338c-22.52-53.23-54.74-101.03-95.78-142.07-41.04-41.04-88.84-73.27-142.08-95.78C630.87 76.82 572.33 65 512 65s-118.87 11.82-174 35.14c-53.23 22.52-101.03 54.74-142.07 95.78-41.04 41.04-73.27 88.84-95.78 142.07C76.82 393.13 65 451.67 65 512c0 60.33 11.82 118.87 35.14 174 22.52 53.23 54.74 101.03 95.78 142.08 41.04 41.04 88.84 73.27 142.07 95.78C393.13 947.18 451.67 959 512 959c60.33 0 118.87-11.82 174-35.14 53.23-22.52 101.03-54.74 142.08-95.78 41.04-41.04 73.27-88.84 95.78-142.08C947.18 630.87 959 572.33 959 512s-11.82-118.87-35.14-174zM512 895c-211.19 0-383-171.81-383-383s171.81-383 383-383 383 171.81 383 383-171.81 383-383 383z" p-id="2782"></path><path d="M680 480H544V344c0-17.67-14.33-32-32-32s-32 14.33-32 32v136H344c-17.67 0-32 14.33-32 32s14.33 32 32 32h136v136c0 17.67 14.33 32 32 32s32-14.33 32-32V544h136c17.67 0 32-14.33 32-32s-14.33-32-32-32z" p-id="2783"></path></svg>' // 可选
        this.tag = 'button'
      }

      // 获取菜单执行时的 value ，用不到则返回空 字符串或 false
      getValue(editor) {   // TS 语法
        // getValue(editor) {                              // JS 语法
        return ' hello '
      }

      // 菜单是否需要激活（如选中加粗文本，“加粗”菜单会激活），用不到则返回 false
      isActive(editor) {  // TS 语法
        // isActive(editor) {                    // JS 语法
        return false
      }

      // 菜单是否需要禁用（如选中 H1 ，“引用”菜单被禁用），用不到则返回 false
      isDisabled(editor) {   // TS 语法
        // isDisabled(editor) {                     // JS 语法
        return false
      }

      // 点击菜单时触发的函数
      exec(editor, value) {   // TS 语法
        // exec(editor, value) {                              // JS 语法
        // if (this.isDisabled(editor)) return
        // editor.insertText(value) // value 即 this.value(editor) 的返回值
        const formulaElem = {
          type: 'formula',
          name: undefined,
          defaultValue: undefined,
          show: false,
          children: [{ text: '' }], // void node 需要有一个空 text
        }

        if (this.isDisabled(editor)) return

        editor.insertNode(formulaElem)
        editor.focus()
        // editor.deselect()
        // editor.restoreSelection()
        editor.move(1)
      }


    }
    const _this = this


    const module = {
      editorPlugin(editor) {
        const { isInline, isVoid } = editor
        const newEditor = editor

        // 重写 isInline
        newEditor.isInline = elem => {
          const type = E.DomEditor.getNodeType(elem)
          if (type === 'formula') {
            return true
          }

          return isInline(elem)
        }

        // 重写 isVoid
        newEditor.isVoid = elem => {
          const type = E.DomEditor.getNodeType(elem)
          if (type === 'formula') {
            return true
          }

          return isVoid(elem)
        }

        return newEditor
      },
      renderElems: [{
        type: 'formula', // 节点 type ，重要！！！
        renderElem(elem, children, editor) {
          const selected = E.DomEditor.isNodeSelected(editor, elem)
          // console.log(editorContent, 'asdasd????');
          const selectedElem = getSelectedElem(editor)
          if (selectedElem) {

          } else {
            editor.children.forEach((item, i1) => {
              if (item.children) {
                item.children.forEach((item2, i2) => {
                  if (item2.type === 'formula') {
                    E.SlateTransforms.setNodes(editor, { show: false, }, { at: [i1, i2] })
                  }
                })
              }
            })
          }

          _this.editor22 = editor

          let showText = _this.listMap[elem.name]
          // console.log()
          let bool = !(elem.name)
          // E.SlateTransforms.setNodes(editor, { show: false  })
          const lis = _this.metaUser.map(item => {
            const active = item.propertyName === elem.name
            return h(
              'li',
              {
                on: {
                  click() {
                    const selectedElem = getSelectedElem(editor)
                    if (selectedElem == null) return

                    const path = E.DomEditor.findPath(editor, selectedElem)
                    E.SlateTransforms.setNodes(editor, { name: item.propertyName, }, { at: path })

                    _this.modal1 = true
                    _this.value = elem.defaultValue

                    _this.path22 = path
                  }
                },
                className: `select-hover-background ${active ? 'select-hover-background-active' : ''}`,
                style: {
                  padding: '0',
                  margin: '0',
                  'font-size': '14px',
                  padding: '7px 15px',
                  'white-space': 'nowrap',
                  width: '100%',
                }
              },
              item.cname
            )
          })


          const formulaVnode = h(
            'div',
            {
              // dataset: { value, defaultValue },
              style: {
                display: 'flex',
                'height': '33px',
                'border-radius': '40px',
                'align-items': 'center',
                'justify-content': 'center',
                'border': '1px solid #ccc',
                'background-color': '#f5f8fc',
                cursor: 'pointer'
              }
            },
            [
              h(
                'div',
                {
                  style: { padding: '0px 5px' }
                },
                h(
                  'i',
                  {
                    className: 'ivu-icon ivu-icon-ios-search'
                  }
                )
              ),
              h(
                'div',
                {
                  style: {
                    'min-width': '76px',
                    background: '#fff',
                    padding: '0 10px',
                    height: '100%',
                    'border-radius': '4px',
                    border: '1px solid #dcdee2',
                    display: 'flex',
                    'justify-content': 'center',
                    'alignItems': 'center',
                    position: 'relative'
                  },
                  on: {
                    click(e) {

                      const domSelection = document.getSelection()
                      if (!domSelection) return
                      const domRange = domSelection.getRangeAt(0)
                      if (domRange == null) return


                      const selectedElem = getSelectedElem(editor)
                      if (selectedElem == null) return

                      const path = E.DomEditor.findPath(editor, selectedElem)
                      E.SlateTransforms.setNodes(editor, { show: !elem.show }, { at: path })


                    }
                  },
                },

                [

                  h('span', {
                    style: {
                      color: bool ? '#c5c8ce' : '#1d2129'
                    }
                  }, bool ? '请选择' : (showText)),
                  h(
                    'ul',
                    {
                      style: {
                        'z-index': '9999999',
                        display: elem.show ? 'block' : 'none',
                        position: 'absolute',
                        'min-width': '100%',
                        width: 'fit-content',
                        'max-height': '250px',
                        overflow: 'auto',
                        'background-color': '#fff',
                        top: '130%',
                        left: '0',
                        padding: '0',
                        'box-shadow': 'rgba(0, 0, 0, 0.2) 0px 1px 6px',

                      }
                    },
                    lis
                  )
                ]
              ),
              h(
                'div',
                {
                  style: { padding: '0px 5px' },
                  on: {
                    click() {
                      _this.modal1 = true
                      _this.value = elem.defaultValue
                      const selectedElem = getSelectedElem(editor)
                      if (selectedElem == null) return
                      const path = E.DomEditor.findPath(editor, selectedElem)
                      _this.path22 = path
                    }
                  }
                },
                h(
                  'i',
                  {
                    className: 'ivu-icon ivu-icon-md-build'
                  }
                )
              )


            ]
          )

          function getSelectedElem(editor) {
            const node = E.DomEditor.getSelectedNodeByType(editor, 'formula')
            if (node == null) return null
            return node
          }



          // console.log(formulaVnode, 'formulaVnode')
          // // 构建容器 vnode


          // const x = toVNode(dom)

          const containerVnode = h(
            'div',
            {
              props: {
                contentEditable: false, // 不可编辑
              },
              style: {
                display: 'inline-block', // inline
                marginLeft: '3px',
                marginRight: '3px',
                // border: selected // 选中/不选中，样式不一样
                //   ? '2px solid var(--w-e-textarea-selected-border-color)' // wangEditor 提供了 css var https://www.wangeditor.com/v5/theme.html
                //   : '2px solid transparent',
                borderRadius: '3px',
                padding: '3px 3px',
              },
              on: {
                click() {

                }
              }
            },
            [
              formulaVnode
            ]
          )




          return containerVnode
        },
      }],
      elemsToHtml: [{
        type: 'formula', // 节点 type ，重要！！！
        elemToHtml(elem, childrenHtml) {
          const { name = '', defaultValue = '', show = false } = elem
          return `<span data-w-e-type="formula" data-w-e-is-void data-w-e-is-inline data-name="${name}" data-defaultValue="${defaultValue}" data-show="${show}"></span>`
        },
      }],
      parseElemsHtml: [{
        selector: 'span[data-w-e-type="formula"]',
        parseElemHtml(elem, children, editor) {
          const name = elem.getAttribute('data-name') || ''
          const defaultValue = elem.getAttribute('data-defaultValue') || ''
          const show = elem.getAttribute('data-show') || ''
          return {
            type: 'formula',
            name,
            defaultValue,
            show,
            children: [{ text: '' }], // void node 必须有一个空白 text
          }
        },
      }],
      menus: [{
        key: 'insertFormula', // menu key ，唯一。注册之后，可配置到工具栏
        factory() {
          return new InsertFormulaMenu()
        },
      }]
    }
    E.Boot.registerModule(module)



  },
  beforeDestroy() { },
};
</script>

<style>
html,
body {
  width: 100%;
  height: 100%;
  background: #f0f0f0;
  overflow: hidden;
}

.app-main {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

tbody {
  overflow-y: scroll;
}

.w-e-modal {
  max-height: unset !important;
  min-height: unset;
  padding: 20px !important;

}
</style>


<style>
.none-select .ivu-select-selection {
  opacity: 0;
}

.select-hover-background:hover {
  background-color: #f3f3f3 !important;
}

.select-hover-background-active {
  background-color: #f3f3f3 !important;
  color: #0084FF;
}

.w-e-scroll {
  overflow: visible !important;
  height: 100%;
}

.w-e-bar-item button::after {
  content: '插入属性';
  border: none;
  opacity: unset;
  position: unset;
  top: unset;
  transition: unset;
  visibility: unset;
  margin-left: 4px;
}

.w-e-text-container [data-slate-editor] p {
  margin: 10px 0 0 !important;
}

.w-e-text-container [data-slate-editor] {
  min-height: var(--min-height) !important;
}

::-webkit-scrollbar {
  width: 8px;
  height: 6px;
  border-radius: 50%;
}

/* 自定义滚动条轨道 */
::-webkit-scrollbar-track {
  background: transparent;
  /* 设置轨道的背景颜色 */
}

/* 自定义滚动条的滑块（thumb） */
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #c1c1c1;
}

/* 当滑块悬停或活动时自定义滚动条的滑块 */
::-webkit-scrollbar-thumb:hover {
  background: #7d7d7d;
  /* 设置滑块在悬停状态下的背景颜色 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue